<aside id="rule-{{name | RemoveWhitespace}}" [ngClass]="{'transition-height': dataRule.viewState.expanded}"
       class="expandable-height">
  <form [formGroup]="form" (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()">
    <h2 [ngClass]="{'heading-underline': dataRule.viewState.expanded}">
      <i class="bhi-search" (click)="onRuleClick()"></i>
      <input *ngIf="showNameInput" type="text" formControlName="name" placeholder="Enter new rule name..."
             (mouseover)="onNameMouseOver($event.target)" (blur)="onNameBlur()" (keydown.enter)="onNameBlur()"
             #focusElement @transitionNewWidthInOut required>
      <span *ngIf="!dataRule.viewState.expanded" class="rule-title"
            (click)="onRuleClick()">
        {{name}}
      </span>
      <span *ngIf="!showNameInput && dataRule.viewState.expanded" class="rule-title" [matTooltip]="'Click to edit name'" matTooltipShowDelay="500"
            (click)="onNameClick()">
        {{name}}
        <i class="material-icons notranslate">edit</i>
      </span>
      <ul id="actions-preview" *ngIf="dataRule.ruleData.action.config"
          (click)="toggleView()">
        <li>| &nbsp;Actions:</li>
        <li *ngFor="let action of dataRule.ruleData.action.config.steps" class="grey">
          <span *ngIf="action.type === 'REPLACE_RELATIVE'; else actionType">REPLACE</span>
          <ng-template #actionType>{{action.type}}</ng-template>
        </li>
      </ul>
    </h2>

    <section
      *ngIf="dataRule.viewState.expanded"
      class="rule-content content grid-2"
      @transitionNewHeightInOut>
      <ul id="criteria">
        <h3 class="heading-underline">Find all field values from</h3>
        <li *ngFor="let criteriaGroup of criteria.controls; let i = index" id="rule-{{i}}">
          <section [ngClass]="[criteria.controls.length > 1 ? 'multiple-criteria': '']">
            <i *ngIf="i > 0" id=" remove-criteria-{{i}}" class="bhi-times" (click)="removeCriteria(i)"
               [matTooltip]="'Remove this criteria'" matTooltipShowDelay="500"></i>
            <app-criteria
              id="rule-{{ruleIndex}}-criteria-{{i}}" [formGroup]="criteriaGroup"
              [criteria]="parseRawCriteria(dataRule.ruleData.source.config.criteria[i]) | async"
              [primaryEntity]="selectedEntity"
            ></app-criteria>
            <span *ngIf="i < criteria.controls.length - 1" class="and"> AND </span>
          </section>
          <button *ngIf="i == criteria.controls.length - 1" type="button" (click)="addNewCriteria()" theme="small"><i
            class="bhi-add-thin"></i> Add Criteria
          </button>
        </li>
        <li class="record-update-limit" *ffEnabled="'feature_kdata_4249_datarules_record_update_limit'">
          <label for="record-update-limit">Record update limit:</label>
          <input id="record-update-limit" type="number" formControlName="recordUpdateLimit"
                 min="1" step="1" placeholder="No limit"
                 oninput="validity.valid||(value='');"
                 [matTooltip]="'Stops this rule once it has updated this many records in a single run. Records that need no update do not count towards it.'"
                 matTooltipShowDelay="500">
        </li>
      </ul>
      <ul id="actions">
        <h3 class="heading-underline">Actions to manipulate field data</h3>
        <div class="message tip" [class.stacked-above-tip]="aiContentDisclaimerVariant"><i class="material-icons notranslate">info_outline</i> To amend an existing Rule action, please remove the
          field and re-add.
        </div>
        @if (aiContentDisclaimerVariant) {
          <app-ai-content-disclaimer [variant]="aiContentDisclaimerVariant" [stackedBelowTip]="true"></app-ai-content-disclaimer>
        }
        <li *ngIf="form.errors?.toOnes" class="rule-error">
          <section class="mat-warn"><i class="bhi-caution"></i>{{form.errors.toOnes.message}}</section>
        </li>
        <li *ngFor="let actionGroup of actions.controls; let i = index" [ngSwitch]="dataRule.ruleData.action.config.steps[i].type">
          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.INSERT)">
            <!-- Check destinationType to differentiate between Certification and Note -->
            <section *ngIf="dataRule.ruleData.action.config.steps[i].destinationType === 'NOTE'">
              <i id="remove-add-note-action-{{i}}" class="bhi-times" (click)="removeAction(i)"></i>
              <app-action-add-note id="rule-{{ruleIndex}}-add-note-action-{{i}}"
                                 [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                 [actionForm]="actionGroup"
                                 [primaryEntity]="selectedEntity">
              </app-action-add-note>
            </section>
            <section *ngIf="dataRule.ruleData.action.config.steps[i].destinationType !== 'NOTE'">
              <i id="remove-insert-action-{{i}}" class="bhi-times" (click)="removeAction(i)"></i>
              <app-action-insert id="rule-{{ruleIndex}}-insert-action-{{i}}"
                                 [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                 [actionForm]="actionGroup"
                                 [primaryEntity]="selectedEntity">
              </app-action-insert>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.INSERT_MULTIPLE)">
            <section>
              <i id="remove-insert-multiple-action-{{i}}" class="bhi-times" (click)="removeAction(i)"></i>
              <app-action-insert-multiple id="rule-{{ruleIndex}}-insert-multiple-action-{{i}}"
                                          [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                          [actionForm]="actionGroup"
                                          [primaryEntity]="selectedEntity">
              </app-action-insert-multiple>
            </section>
          </ng-container>

          <ng-container
            *ngSwitchCase="dataRulesService.actionOpName(actionOperators.DELETE)">
            <section>
              <i id="remove-delete-action-{{i}}" class="bhi-times" (click)="setHardDelete(false)"></i>
              <app-hard-delete
                [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                [actionForm]="actionGroup"
                [primaryEntity]="selectedEntity"
              ></app-hard-delete>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.AIASSIST)">
            <section>
              <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-ai id="rule-{{ruleIndex}}-action-{{i}}"
                             [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                             [actionForm]="actionGroup"
                             [primaryEntity]="selectedEntity">
              </app-action-ai>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.AIASSIST_NOTE)">
            <section>
              <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-ai id="rule-{{ruleIndex}}-action-{{i}}"
                             [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                             [actionForm]="actionGroup"
                             [primaryEntity]="selectedEntity">
              </app-action-ai>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.AWESOMEDOCS)">
            <section class="action-with-heading">
              <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-awesome-docs id="rule-{{ruleIndex}}-action-{{i}}"
                                       [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                       [actionForm]="actionGroup"
                                       [primaryEntity]="selectedEntity">
              </app-action-awesome-docs>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.ENRICH)">
            <section class="action-with-heading">
              <i id="remove-enrich-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-trust-score id="rule-{{ruleIndex}}-enrich-action-{{i}}"
                                      [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                      [actionForm]="actionGroup"
                                      [primaryEntity]="selectedEntity">
              </app-action-trust-score>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.PARSE_RESUME)">
            <section class="action-with-heading">
              <i id="remove-parse-resume-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-parse-resume id="rule-{{ruleIndex}}-parse-resume-action-{{i}}"
                                       [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                       [actionForm]="actionGroup"
                                       [primaryEntity]="selectedEntity">
              </app-action-parse-resume>
            </section>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <section>
              <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <!--          <app-actions id="rule-{{ruleIndex}}-action-{{i}}" [formGroup]="actionGroup" [actionData]="dataRule.ruleData.action.config.steps[i]" [fieldMetaData]="actionMeta"></app-actions>-->
              <app-action-x id="rule-{{ruleIndex}}-action-{{i}}"
                            [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                            [actionForm]="actionGroup"
                            [primaryEntity]="selectedEntity">
              </app-action-x>
            </section>
          </ng-container>
        </li>

        <aside [ngClass]="'actions-buttons'">
          <!-- TODO: Show this button if destination is populated in last (FYI value is also populated in add-remove, change, replace) -->
          <!-- TODO: ngx-skeleton-loader can be done ourselves easily, pull it out -->
          <ng-container *ngIf="canSpawnAddActionButton()">
            <button class="add-action" theme="small" type="button" (click)="addNewAction()">
              <i class="bhi-field-add"></i>Add Action
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnCredentialRequirementButton()">
            <button class="add-credential-requirement" theme="small" type="button" (click)="addNewInsertCredentialsRequirementAction()">
              <i class="bhi-field-add"></i>Add Credential Requirement
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnMultipleCredentialRequirementButton()">
            <button class="add-credential-requirement-group" theme="small" type="button" (click)="addNewInsertMultipleCredentialsRequirementAction()">
              <i class="bhi-field-add"></i>Add Credential Requirements based on Certification Group
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnHardDeleteButton()">
            <button [ngClass]="{
                'hard-delete': true,
                'selected': isHardDelete.value
            }" theme="small" type="button"
                    (click)="setHardDelete(!isHardDelete.value)">
              <i class="bhi-field-add"></i>Hard delete
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnAddNoteButton()">
            <button (click)="addNewAddNoteAction()" theme="small" type="button">
              <i class="bhi-field-add"></i>Add Note
            </button>
          </ng-container>
        </aside>
        <hr/>
        <aside [ngClass]="'actions-buttons'">
          <ng-container *ngIf="canSpawnAddAIActionButton()">
            <button (click)="addNewAIAction()" theme="small" type="button">
              <i class="bhi-field-add"></i>GENERATE KYLOE AI PROMPT
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnAddAwesomeDocsButton()">
            <button *ffEnabled="'datarules_awesome_docs_action'" (click)="addNewAwesomeDocsAction()" theme="small" type="button">
              <i class="bhi-field-add"></i>GENERATE KYLOE AWESOMEDOCS TEMPLATE
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnEnrichButton()">
            <button *ffEnabled="'datarules_enrichment_action'" (click)="addNewEnrichAction()" theme="small" type="button">
              <i class="bhi-field-add"></i>Enrichment
            </button>
          </ng-container>
          <ng-container *ngIf="canSpawnParseResumeButton()">
            <button *ffEnabled="FeatureFlagService.FLAGS.dataRulesParseResume" (click)="addNewParseResumeAction()" theme="small" type="button">
              <i class="bhi-field-add"></i>Parse Resume
            </button>
          </ng-container>
        </aside>
      </ul>
    </section>

    <section
      *ngIf="dataRule.viewState.expanded && currentRuleExamples && utilsService.compareInternalDataRuleIds(currentRuleExamples.id, dataRule.ruleData.id) && !form.dirty && form.valid"
      class="rule-content content"
      @transitionNewHeightInOut>
      <app-examples-found id="examples-found"
                          [ngClass]="{'transition-height': currentRuleExamples}"
                          class="standalone-button"
                          [currentRuleExamples]="currentRuleExamples"
                          [selectedEntity]="selectedEntity"
                          [entityMap]="entityMap"
                          [tasksInProgress]="tasksRunning"
                          [dataRule]="dataRule"
      ></app-examples-found>
    </section>

    <section [ngClass]="[form.valid && form.dirty ? 'transition-height' : 'hide-height']" class="footer-btns">
      <button theme="nav" type="submit" [disabled]="!form.valid || !form.dirty || form.errors || disableSaveButton ">SAVE <i
        class="material-icons notranslate">backup</i></button>
    </section>
  </form>
  <!--<span style="background-color: lightgreen">{{form.value | json}} | valid={{form.valid}}, dirty={{form.dirty}}</span>-->
</aside>
